export default __webpack_public_path__ + "static/4-853015e9b752021ca9c9cb0cbd81eb3f.jpeg";